import React from "react";

const Button = ({ addItem }) => <button onClick={addItem}>Add to cart</button>;

export default Button;
